import { RESET_STUDIO_ACTION } from '../consts';
import type { PreviewControl, PreviewControlField, PreviewControlGlobal } from '../../types/PreviewControl';
import type { StudioPreviewControlsActions } from '../../actions/studio/preview-controls';

export interface State {
    all: PreviewControl[];
    field: PreviewControlField[];
    global: PreviewControlGlobal[];
}

const getDefaultState = (): State => ({
    all: [],
    field: [],
    global: []
});

const studioPreviewControlsReducer = (state = getDefaultState(), action: StudioPreviewControlsActions | null): State => {
    switch (action?.type) {
        case 'STUDIO_SET_CUSTOM_CONTROLS': {
            const { all, field, global } = action.data;
            return {
                ...state,
                all,
                field,
                global
            };
        }

        case RESET_STUDIO_ACTION: {
            return getDefaultState();
        }

        default: {
            return state;
        }
    }
};

export default studioPreviewControlsReducer;
